import router from '@/router';

import { getOpenWindowProperties } from '@/functions/pages/contract_diff';
export const diff = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    windowName: 'ContractDiff'
  },
  actions: {
    openWindow({ state }) {
      const routeData = router.resolve({
        name: 'ContractDiff'
      });
      window.open(routeData.href, state.windowName, getOpenWindowProperties());
    },
    destroy({ state }) {
      setTimeout(() => {
        window.open('', state.windowName, true).close();
      }, 1);
      localStorage.removeItem('ContractDiff');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/diff.js